// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

interface ExternalLinkProps {
    className?: string;
    url?: string;
    title?: string;
    children: ReactNode;
}

const ExternalLink = ({ url, children, className, title = '' }: ExternalLinkProps): ReactElement =>
    url ? (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => {
                event.stopPropagation();
            }}
            title={title}
            className={classList(className)}
        >
            {children}
        </a>
    ) : (
        <span className={classList(className)}>None</span>
    );

export default ExternalLink;
